"use client";
import { createContext, useState } from "react";

// Create the context
const UserCtx = createContext({
  user: null,
  setUser: (user: any) => {},
  newUser: null,
  setNewUser: (newUser: any) => {},
});

// Create a provider component
export const UserProvider = ({ children }: any) => {
  const [user, setUser] = useState(null);
  const [newUser, setNewUser] = useState(null);
  const context = { user, setUser, newUser, setNewUser };
  return <UserCtx.Provider value={context}>{children}</UserCtx.Provider>;
};

export default UserCtx;
